
<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col class="text-center">
        <h1>CREATE</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
    name: "Create"
};
</script>

<style scoped>

</style>
